import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import NewPostForm from "../../../../components/Admin/Publication/NewPostForm";
import { getCatWithoutNotesApi } from '../../../../api/category';
import { getSubCategoriesApi } from '../../../../api/subcategory';
import { getTagsApi } from '../../../../api/tag';
import Modal from "../../../../components/Modal";
import AddEditSubCatForm from '../../../../components/Admin/SubCategory/AddEditSubCatForm';
import { errorModal, warningModal } from '../../../../components/Alerts/Alerts';

import "./NewPublication.scss";

function NewPublication(props) {
    const [ categorias, setCategories ] = useState([]);
    const [ subcategorias, setSubCategories ] = useState([]);
    const [ etiquetas, setTags ] = useState([]);
    const [ reloadCat, setReloadCat ] = useState(false);
    const [ reloadSubCat, setReloadSubCat ] = useState(false);
    const [ reloadTag, setReloadTag ] = useState(false);
    const [ isVisibleModal, setIsVisibleModal ] = useState(false);
    const [ modalTitle, setModalTitle ] = useState("");
    const [ modalContent, setModalContent ] = useState(null);
    // eslint-disable-next-line no-unused-vars
    const [ subCategoriesBase, setSubCategoriesBase ] = useState(null);
    const [ reloadsubCategoriesBase, setReloadsubCategoriesBase ] = useState(false);

    useEffect(() => {
        getCatWithoutNotesApi().then(response => {
            setCategories(response.category);
        });

        setReloadCat(false);
    }, [reloadCat]);

    useEffect(() => {
        getSubCategoriesApi().then(response => {
            setSubCategories(response.subCategory);
        });

        setReloadSubCat(false);
    }, [reloadSubCat]);

    useEffect(() => {
        getTagsApi().then(response => {
            setTags(response.tag);
        })

        setReloadTag(false);
    }, [reloadTag]);

    useEffect (() => {
        getSubCategoriesApi()
            .then(response => {
                if (response.code && response.code !== 200){
                    warningModal("Advertencia", response.message);
                }else{
                    setSubCategoriesBase(response.subCategory);
                }
            })
            .catch(err => {
                errorModal	("Error", "Error del Servidor.");
            });
            setReloadsubCategoriesBase(false);
    }, [reloadsubCategoriesBase]);

    const newSubcategory = e => {
        setIsVisibleModal(true);
        setModalTitle("Nueva Subcategoría");
        setModalContent(
                <AddEditSubCatForm
                    setIsVisibleModal={setIsVisibleModal}
                    setReloadSubCategories={setReloadSubCat}
                    subCategories={null}
                    subCategoriesBase={null}
                    setReloadsubCategoriesBase={setReloadsubCategoriesBase}
                    categories={categorias}
                    setReloadSubCategoriesDeta={setReloadSubCat}
                />
            );
    }

    return (
        <>
            <NewPostForm 
                categories={categorias} 
                subcategories={subcategorias}
                tags={etiquetas}
                reloadCat={reloadCat} 
                reloadSubCat={reloadSubCat} 
                reloadTag={reloadTag}
                newSubcategory={newSubcategory}
                setReloadSubCat={setReloadSubCat}
            />

            <Modal
                title={modalTitle}
                isVisible={isVisibleModal}
                setIsVisible={setIsVisibleModal}
                setSize='md'
            >
                {modalContent}
            </Modal>
        </>
    )
}

export default withRouter(NewPublication);